import { gql } from '@apollo/client';

export const FETCH_DATA_IMPORTERS = gql`
    query fetchDataImporters($filter: DataImporterFilterInput) {
        facility {
            id
            configurations {
                dataImporters(filter: $filter) {
                    id
                    name
                    type
                    description
                    isRestricted
                    configuration
                    state
                    isStateful
                }
            }
        }
    }
`;
